import React from 'react';
import { Table } from 'antd';
import { NameOf, TableExpressions } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import GroupTypeDTO from 'src/models/generated/GroupTypeDTO';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';

export interface GroupTypeTableProps {
    data?: GroupTypeDTO[];
    loading?: boolean;
    filterStrings: string[];
}

const GroupTypeTable: React.FC<GroupTypeTableProps> = (props) => {

    const tableColumns: ColumnProps<GroupTypeDTO>[] = [
        TableColumnBuilder.Create<GroupTypeDTO>('groupType', 'Group Type')
            // .Width(400)
            .AddSorter('Text')
            .AddEnumFilterer(props.filterStrings, 'Exact Text')
            .AddRenderer('Ellipses')
            .Build(),
        TableColumnBuilder.Create<GroupTypeDTO>('subType', 'Sub Type')
            // .Width(400)
            .AddSorter('Text')
            .AddTextFilterer()
            .AddRenderer('Ellipses')
            .Build(),
        TableColumnBuilder.Create<GroupTypeDTO>('groupId', 'Group Id')
            // .Width(400)
            .AddSorter('Text')
            .AddTextFilterer()
            .AddRenderer('Ellipses')
            .Build(),
        TableColumnBuilder.Create<GroupTypeDTO>('groupName', 'Name')
            // .Width(400)
            .AddSorter('Text')
            .AddTextFilterer()
            .AddRenderer('Ellipses')
            .Build(),
        //TableColumnBuilder.Create<GroupTypeDTO>('modified', 'Modified')
        //  // .Width(400)
        //  .AddSorter('Date')
        //  .AddDateFilterer()
        //  .AddRenderer('ShortDate', false)
        //  .Build(),
    ];

    return <>
        <Table
            rowKey={NameOf<GroupTypeDTO>('id')}
            className='condensed-table striped-table'
            rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
            loading={props.loading}
            pagination={false}
            columns={tableColumns}
            dataSource={props.data}
        />
    </>;
};

export default GroupTypeTable;
